import { useLocation } from '@reach/router';
import ModalLayout, {
  closeTimeoutMS,
  defaultModalStyles,
} from '@src/components/layout/modalLayout';
import { getSurveyInfo } from '@src/services/auth';
import { useUser } from '@src/services/userContext';
import api from '@src/utils/api.js';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import { Box, Button, Grid } from 'theme-ui';
import './SurveyBox.scss';
import SurveyForm from './SurveyForm';
import SurveyRightSide from './SurveyRightSide';
import { surveyQuestions } from './surveyData';

export default function SurveyBox() {
  const [isSurveyOpen, setIsSurveyOpen] = useState(false);
  const [isFormCompleted, setIsFormCompleted] = useState(false);
  const [surveyQuestion, setSurveyQuestion] = useState(0);
  const { t } = useTranslation();
  const user = useUser();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const openSurvey = () => {
    setIsSurveyOpen(true);
  };
  const checkIfSurveyEnabled = async () => {
    const surveyInfo: any = getSurveyInfo();
    if ((surveyInfo && surveyInfo.surveyCompleted) || isHomePage) {
      return;
    } else if (window.sessionStorage.getItem('noSurvey')) {
      return;
    } else if (user?.userToken) {
      const isSurveyEnabled = await checkUserSurveyEnabledStatus(user.id);
      if (isSurveyEnabled) {
        setTimeout(openSurvey, 10000);
      }
    } else {
      setTimeout(openSurvey, 10000);
    }
  };
  const checkUserSurveyEnabledStatus = async (userId: number) => {
    try {
      const response = await api.get(`public/userIsSurveyEnabled/${userId}`);
      if (response.survey_enabled) {
        return true;
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    checkIfSurveyEnabled();
  }, []);
  useEffect(() => {
    if (isSurveyOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isSurveyOpen]);
  const [isFixedWidthDontFit, setIsFixedWidthDontFit] = useState(false);

  const handleResize = () => {
    if (window.innerWidth < 1300) {
      setIsFixedWidthDontFit(true);
    } else {
      setIsFixedWidthDontFit(false);
    }
  };
  useEffect(() => {
    window.addEventListener('resize', handleResize);
  }, []);
  return (
    <>
      <ReactModal
        isOpen={isSurveyOpen}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        ariaHideApp={false}
        closeTimeoutMS={closeTimeoutMS}
        style={defaultModalStyles}
      >
        <ModalLayout>
          <Box
            bg="white"
            sx={{
              position: 'relative',
              borderRadius: '10px',
              width: '90vw',
              maxWidth: '1626px',
              height: isFixedWidthDontFit ? 'auto' : '841px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {surveyQuestion > 0 && !isFormCompleted && (
              <div
                className="survey-box__progress-bar-container"
                style={{
                  display: 'flex',
                }}
              >
                {Array.from(
                  { length: surveyQuestions.length - 1 },
                  (_, i) => i + 1
                ).map((i) => (
                  <div
                    key={i}
                    className="survey-progress-bar"
                    sx={{
                      margin: '0 2px',
                      backgroundColor:
                        i <= surveyQuestion ? 'primary' : '#D4E1FF',
                    }}
                  ></div>
                ))}
              </div>
            )}
            {!isFormCompleted ? (
              <Grid columns={[1, 1, 2]} gap={0} sx={{ height: '100%' }}>
                <Box className="survey-box__left-side">
                  <SurveyForm
                    setIsSurveyOpen={setIsSurveyOpen}
                    setIsFormCompleted={setIsFormCompleted}
                    surveyQuestion={surveyQuestion}
                    setSurveyQuestion={setSurveyQuestion}
                  />
                </Box>
                <SurveyRightSide surveyQuestion={surveyQuestion} />
              </Grid>
            ) : (
              <Box
                p={['40px']}
                sx={{
                  height: '100%',
                  textAlign: 'center',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <Box sx={{ position: 'relative', zIndex: 1, padding: '20x' }}>
                  {' '}
                  <Box className="survey-final-box question-title">
                    <div className="survey-final-box__image"></div>
                    <div style={{ padding: '0 20px' }}>
                      {t('survey.weWillContactYou')}
                    </div>
                  </Box>
                  <Button
                    className="larger-font-size"
                    style={{ margin: '40px 0 80px 0' }}
                    onClick={() => setIsSurveyOpen(false)}
                  >
                    {t('survey.backToMain')}
                  </Button>{' '}
                </Box>
                <Box className="survey-final-bg-box" bg="primaryPaleBg"></Box>
              </Box>
            )}
          </Box>
        </ModalLayout>
      </ReactModal>
    </>
  );
}
